export default __webpack_public_path__ + "static/media/Ibrahim.c6eada82.jpg";